// import 'materialize-css/dist/js/materialize.js';
import "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import { trackEvent } from './event.js';
window.trackEvent = trackEvent;
import { checkStatus } from './portal-progress.js';
window.checkStatus = checkStatus;

document.getElementById('go-back')?.addEventListener('click', () => {
    history.back();
});

$.validator.addMethod(
    "regex",
    function (value, element, regexp) {
        var re = new RegExp(regexp);
        return this.optional(element) || re.test(value);
    },
    "Please check your input."
);